import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import {
  BiddingTypeEnum,
  ItemTypeEnum,
  SlimItemsEntity,
} from 'libs/gb-dashboard/item/data-access/src/lib/+state/items.models'

@Component({
  selector: 'gb-item-type-chip',
  templateUrl: './gb-item-type-chip.component.html',
  styleUrls: ['./gb-item-type-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GbItemTypeChipComponent {
  @Input({ required: true }) item!: SlimItemsEntity
  @Input() disableTruncate = false

  get itemType(): ItemTypeEnum | BiddingTypeEnum {
    const itemType = this.item.item_type
    if (itemType !== ItemTypeEnum.Bidding) return itemType

    const biddingItem = this.item.bidding_item
    if (biddingItem?.live_auction_item) return BiddingTypeEnum.Live
    if (biddingItem?.sealed_bid_item) return BiddingTypeEnum.Sealed
    return BiddingTypeEnum.Silent
  }

  get translateKey(): string {
    return `ITEMS.TYPE.${this.itemType.toUpperCase()}`
  }
}
